package com.sweetlime.bingeamigo.presentation.features.moviedetail

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.sweetlime.bingeamigo.model.MovieDetail
import com.sweetlime.bingeamigo.repository.TmdbRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

sealed class MovieDetailState {
    data object Loading : MovieDetailState()
    data class Success(val detail: MovieDetail) : MovieDetailState()
    data class Error(val message: String) : MovieDetailState()
}

class MovieDetailViewModel(
    private val repository: TmdbRepository
) : ViewModel() {

    private val _state = MutableStateFlow<MovieDetailState>(MovieDetailState.Loading)
    val state: StateFlow<MovieDetailState> = _state.asStateFlow()

    fun load(movieId: Int) {
        _state.value = MovieDetailState.Loading
        viewModelScope.launch {
            val detail = repository.getMovieDetail(movieId)
            _state.value = if (detail != null) {
                MovieDetailState.Success(detail)
            } else {
                MovieDetailState.Error("Failed to load movie details")
            }
        }
    }
}
